import { postRequest } from '@/core';
import { tripTypes } from '@/requests';

export default async function syncTripTypes() {
	let url = tripTypes.getSyncPath();
	try {
		let response = await postRequest(url);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}